import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class OrgNormRequest {
    static data(props) {
        App.log('ORG_NORM_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({...result.objList[0]?.hospitalEmgRequestFormVM, ...result.objList[0]?.requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static delete(props) {
        App.log('ORG_NORM_REQUEST.DELETE', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            statusId: 21
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.UPDATE_STATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }
}

class HospitalOrgNormRequest extends OrgNormRequest {
    static insert(props) {
        App.log('HOSPITAL_ORG_NORM_REQUEST.INSERT', App.LOG.FETCH, props);

        const body = {
            hospitalNormRequestVM: {
                hospitalNormRequestId: 0,
                wbJson: props?.wbJson || {},
                rbcJson: props?.rbcJson || {},
                lrbcJson: props?.lrbcJson || {},
                pediatrictRBCJson: props?.pediatrictRBCJson || {},
                pltJson: props?.pltJson || {},
                lrpltJson: props?.lrpltJson || {},
                ffpJson: props?.ffpJson || {},
                cppJson: props?.cppJson || {},
                cryJson: props?.cryJson || {},
                specialRBCJson: props?.specialRBCJson || {},
                specialPLTJson: props?.specialPLTJson || {},
                otherSpecialProductJson: props?.otherSpecialProductJson || {}
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.ORG_NORM.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static list() {
        App.log('HOSPITAL_ORG_NORM_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.ORG_NORM.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    // static update (props) {
    //     App.log('ORG_NORM_REQUEST.UPDATE', App.LOG.FETCH, props);
    //
    //     const body = {
    //         sectionNormRequestVM: {
    //             sectionRequestId: props?.sectionRequestId,
    //             sectionNormRequestId: props?.sectionNormRequestId,
    //             // patientFirstName: props?.patientFirstName,
    //             // patientLastName: props?.patientLastName,
    //             // patientFatherName: props?.patientFatherName,
    //             // patientBirthDate: props?.patientBirthDate,
    //             // patientNationalCode: props?.patientNationalCode,
    //             // patientGenderId: props?.patientGenderId,
    //             // patientProvinceId: parseInt(props?.patientProvinceId),
    //             // patientCityId: parseInt(props?.patientCityId),
    //             sectionId: parseInt(props?.sectionId),
    //             // patientFileCode: props?.patientFileCode,
    //             patientFileCodeId: parseInt(props?.patientFileCodeId) || null,
    //             injectionHistory: props?.injectionHistory,
    //             pregnancyHistory: props?.pregnancyHistory,
    //             complicationsHistory: props?.complicationsHistory,
    //             antiBodyHistory: props?.antiBodyHistory,
    //             medicationPrescribeNeed: props?.medicationPrescribeNeed,
    //             medicationName: props?.medicationName,
    //             howToPrescribe: props?.howToPrescribe,
    //             patientDiagnosticId: parseInt(props?.patientDiagnosticId),
    //             patientDiagnosticStr: props?.patientDiagnosticStr,
    //             diseaseCauseId: parseInt(props?.diseaseCauseId) || null,
    //             surgeryTypeId: parseInt(props?.surgeryTypeId),
    //             diseaseCauseOtherReason: props?.diseaseCauseOtherReason,
    //             hemoglobinAmount: parseInt(props?.hemoglobinAmount),
    //             pltamount: parseInt(props?.pltamount || 0) || null,
    //             patientBloodGroupId: parseInt(props?.patientBloodGroupId),
    //             rbccount: parseInt(props?.rbccount || 0),
    //             wbcount: parseInt(props?.wbcount || 0),
    //             lrbccount: parseInt(props?.lrbccount || 0),
    //             ffpcount: parseInt(props?.ffpcount || 0),
    //             pediatricCount: parseInt(props?.pediatricCount || 0),
    //             crycount: parseInt(props?.crycount || 0),
    //             washedRbccount: parseInt(props?.washedRbccount || 0),
    //             washedTime: parseInt(props?.washedTime || 0),
    //             cppcount: parseInt(props?.cppcount || 0),
    //             otherProductsCount: parseInt(props?.otherProductsCount || 0),
    //             otherProductsName: props?.otherProductsName || '',
    //             pltcount: parseInt(props?.pltcount || 0),
    //             requestPurpose: props?.requestPurpose,
    //             needDate: props?.needDate,
    //             injectionVelocity: props?.injectionVelocity,
    //             docterName: props?.docterName,
    //             rhtest: props?.rhtest,
    //             antiBodyTest: props?.antiBodyTest,
    //             crossMatchTest: props?.crossMatchTest,
    //             termsAndConditions: props?.termsAndConditions,
    //             sampler: props?.sampler,
    //             samplerName: props?.samplerName,
    //             samplerLastName: props?.samplerLastName,
    //             bloodSamplingDate: props?.bloodSamplingDate,
    //             bloodSamplingTime: props?.bloodSamplingTime
    //         }
    //     };
    //
    //     return new Promise((resolve, reject) => {
    //         fetch(Api.REQUEST.SECTION.NORM.UPDATE, {
    //             body: JSON.stringify(body),
    //             method: Tool.METHODS.POST,
    //             headers: Tool.headers()
    //         }).then(response => {
    //             Tool.response(response, {
    //                 '200:0': result => {
    //                     resolve();
    //                 },
    //                 'default': result => {
    //                     reject(result.resultMessage);
    //                 }
    //             });
    //         }).catch(_ => {
    //             reject(Resource.STRING.FETCH.INSERT_FAILED);
    //         });
    //     });
    // }
}

class OrganizationOrgNormRequest extends OrgNormRequest {
    static data(props) {
        App.log('ORG_NORM_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({...result.objList[0]?.hospitalNormRequestFormVM, ...result.objList[0]?.requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static list() {
        App.log('ORGANIZATION_ORG_NORM_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.NORM.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export {HospitalOrgNormRequest, OrganizationOrgNormRequest};